(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["iq-product-extra"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-iqpx-open]');
    if (!a) return;
    var d = document.getElementById(a.getAttribute('data-iqpx-open'));
    if (!d) return;
    e.preventDefault();
    d.open = true;
    d.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

})();
